import type { FC } from 'react';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import StudioHeaderMobile from '../../../StudioHeaderMobile';
import { useDraftsSelect } from '../../../../hooks/useDraftsSelect';
import { STUDIO_DEVIATIONS_STREAM } from '../../../../../constants';
import PlaygroundTabs from '../../../playground/PlaygroundTabs';
import DeviationsTab from '../../_partials/DeviationsTab';
import LayoutContainer from '../../_partials/LayoutContainer';
import MobileCreateBanner from '../../../MobileCreateBanner';

interface Props {}

const PlaygroundLayout: FC<Props> = () => {
  const { streamId, streamConfig, streamThrottle } = STUDIO_DEVIATIONS_STREAM;
  const { items: deviations, isFetching } = useNormalizedDeviationStream(streamId, streamThrottle, {
    ...streamConfig,
  });

  const { selected, selectedCount, allIsSelected, hasSelection, onSelect, onSelectAll } =
    useDraftsSelect(deviations);

  return (
    <LayoutContainer>
      <StudioHeaderMobile
        selectedCount={selectedCount}
        allIsSelected={allIsSelected}
        onSelectAll={onSelectAll}
      />
      <DeviationsTab
        elementBeforeList={
          !hasSelection && (
            <>
              <PlaygroundTabs key="tabs" />
              <MobileCreateBanner />
            </>
          )
        }
        deviations={deviations}
        isFetching={isFetching}
        selected={selected}
        hasSelection={hasSelection}
        onSelect={onSelect}
      />
    </LayoutContainer>
  );
};
PlaygroundLayout.displayName = 'PlaygroundLayout';

export default PlaygroundLayout;
